import { API } from "../backend";

export const contactForm = (data) => {
  return fetch(`${API}/contact`, {
    method: "POST",
    headers: {
      "content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((data) => {
      return data.json();
    })
    .catch((err) => console.log(err));
};
